// extracted by mini-css-extract-plugin
export default {"block":"zBFB5x","name":"YuSnk7"};